// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"d8ccfbb7","238":"dfdc3482","681":"16c69cd3","815":"0a06bfd2","994":"5e90d0e9"}[chunkId] + ".chunk.js";
};